import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const About = ({
  subheading,
  heading,
  headingTag = "h2",
  subtext,
  buttonText,
  buttonLink,  
  image,
}) => {
   const MotionHeading = motion[headingTag];
  return (
    <section className="content-image-section">
      <div className="content-wrapper">

        {/* LEFT CONTENT */}
        <motion.div
          className="content-box"
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{
            duration: 0.9,
            ease: [0.22, 1, 0.36, 1],
          }}
          viewport={{ once: true }}
        >
          <motion.p
            className="section-label"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            viewport={{ once: true }}
          >
            {subheading}
          </motion.p>

           <MotionHeading
            className="content-heading"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.35, duration: 0.7 }}
            viewport={{ once: true }}
          >
            {heading}
          </MotionHeading>

          <motion.hr
            initial={{ scaleX: 0, opacity: 0 }}
            whileInView={{ scaleX: 1, opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.6 }}
            style={{ transformOrigin: "left" }}
            viewport={{ once: true }}
          />

          <motion.p
            className="sub-text"
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.65, duration: 0.6 }}
            viewport={{ once: true }}
          >
            {subtext}
          </motion.p>

         {buttonText && buttonLink && (
  <Link to={buttonLink}>
    <motion.button
      className="primary-btn"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      transition={{
        delay: 0.8,
        duration: 0.5,
        type: "spring",
        stiffness: 300,
      }}
      viewport={{ once: true }}
    >
      {buttonText}
    </motion.button>
  </Link>
)}
        </motion.div>

        {/* RIGHT IMAGE */}
        <motion.div
          className="image-box"
          initial={{ opacity: 0, x: 80, scale: 0.9 }}
          whileInView={{ opacity: 1, x: 0, scale: 1 }}
          transition={{
            duration: 1,
            ease: [0.22, 1, 0.36, 1],
          }}
          viewport={{ once: true }}
        >
          <motion.img
            src={image}
            alt={heading}
            whileHover={{ scale: 1.06 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
          />
        </motion.div>

      </div>
    </section>
  );
};

export default About;
